package com.anjuros.website.redesign.sections.faq

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.components.rdFaqJsonLd
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

/** JSON-LD for the FAQ page: every question and answer, and the breadcrumb. */
@Composable
fun faqStructuredData(): String {
    val faq = rdFaqJsonLd(FaqTopics.flatMap { it.faqs })
    val breadcrumb = rdBreadcrumbJsonLd(RdText.FAQS_CRUMB, RdRoute.FAQ)
    return """
        {"@context":"https://schema.org","@graph":[
         $faq,
         $breadcrumb
        ]}
    """.trimIndent()
}
